export const ADVERTISER_LINK = "Advertiser Link";
export const DRAFT_INFO_MESSAGE = "Please be informed that SAVE AS DRAFT will not publish the changes. Click on SAVE & PUBLISH to reflect changes in the redirect engine. Click 'OK' to save as draft.";
